import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import "./component/Dashboard/Dasboard.css";
import AdminLogin from "./component/admin-login/AdminLogin";

const InstallAppsConfig = lazy(() =>
  import("./pages/HomeConfigration/installAppsConfig/InstallAppsConfig")
);
const EditProfile = lazy(() => import("./component/Profile/EditProfile"));
const ChangePassword = lazy(() => import("./component/Profile/ChangePassword"));

// Home Configration
const LoginPopUp = lazy(() =>
  import("./pages/HomeConfigration/LoginPopUp/LoginPopUp")
);
const PromotionHeader = lazy(() =>
  import("./pages/HomeConfigration/PromotionHeader/PromotionHeader")
);
const SubHeader = lazy(() =>
  import("./pages/HomeConfigration/SubHeader/SubHeader")
);
const Header = lazy(() => import("./pages/HomeConfigration/Header/Header"));
const CategoryPatterns = lazy(() =>
  import("./pages/HomeConfigration/Category/CategoryPatterns")
);
const SliderPattern = lazy(() =>
  import("./pages/HomeConfigration/SliderPattern/SliderPattern")
);
const ImageGallery = lazy(() => import("./pages/ImageGallery/ImageGallery"));

const OfferBannerPattern = lazy(() =>
  import("./pages/HomeConfigration/OfferBannerPattern/OfferBannerPattern")
);
const HotDealPattern = lazy(() =>
  import("./pages/HomeConfigration/HotDealPattern/HotDealPattern")
);
const FooterPattern = lazy(() =>
  import("./pages/HomeConfigration/FooterPattern/FooterPattern")
);
const Promises = lazy(() =>
  import("./pages/HomeConfigration/Promises/Promises")
);
const BestSellerPattern = lazy(() =>
  import("./pages/HomeConfigration/BestSellerPattern/BestSellerPattern")
);

const RecentlyViewedPattern = lazy(() =>
  import("./pages/HomeConfigration/RecentlyViewedPattern/RecentlyViewedPattern")
);
const NewArrivalPattern = lazy(() =>
  import("./pages/HomeConfigration/NewArrivalPattern/NewArrivalPattern")
);
const ProductsPattern = lazy(() =>
  import("./pages/ProductsConfigration/ProductsPattern/ProductsPattern")
);
const ProductsDetailsPattern = lazy(() =>
  import("./pages/ProductsDetailsConfigration/ProductsDetailsPattern")
);

const WishListPattern = lazy(() =>
  import("./pages/wishlistConfigration/WishlistConfigration")
);

const CartPattern = lazy(() =>
  import("./pages/cartConfigration/CartConfigration")
);
// setttings
const BusinessDetails = lazy(() => import("./pages/Settings/BusinessDetails"));
const Smtp = lazy(() => import("./pages/Settings/Smtp"));
const PaymentGateway = lazy(() => import("./pages/Settings/PaymentGateway"));

// Push Notification Setting

const PushNotificationSetting = lazy(() =>
  import("./pages/pushNotificationSetting/PushNotificationSetting")
);
const WhatsappSetting = lazy(() =>
  import("./pages/whatsappSetting/WhatsappSetting")
);

/* App Configration */

const AppHeader = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/Header/Header")
);
const AppSlider = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/HomeSlider/AppSlider")
);

const AppCategoryPatterns = lazy(() =>
  import(
    "./pages/AppConfigration/HomeConfigration/Category/AppCategoryPatterns"
  )
);
const AppOfferBanner = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/offerBanner/AppOfferBanner")
);

const AppHotDeal = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/hotDeal/AppHotDeal")
);
const AppBestSeller = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/bestSeller/AppBestSeller")
);
const AppNewArrival = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/newArrival/AppNewArrival")
);

const AppPromises = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/promises/AppPromises")
);

const AppTabBar = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/TabBar/AppTabBar")
);

const SplashScreen = lazy(() =>
  import("./pages/AppConfigration/HomeConfigration/SplashScreen/SplashScreen")
);

const ProductList = lazy(() =>
  import("./pages/AppConfigration/ProductPage/ProductList/ProductList")
);

const ProductDetails = lazy(() =>
  import(
    "./pages/AppConfigration/ProductDetailsPage/ProductDetails/ProductDetails"
  )
);

const RelatedProductPattern = lazy(() =>
  import("./pages/ProductsDetailsConfigration/RelatedProductPattern")
);

const MenuPage = lazy(() =>
  import("./pages/AppConfigration/MenuPage/MenuPage")
);

const CheckOutPage = lazy(() =>
  import("./pages/AppConfigration/CheckOutPage/CheckOutPage")
);

const AdminMenuPage = lazy(() =>
  import("./pages/AdminConfigration/AdminMenuPage/AdminMenuPage")
);

const Routing = () => {
  return (
    <Suspense
      fallback={
        <div className="lazy-loading-main d-flex justify-content-center align-items-center">
          {/* <img
            src={require("./component/assets/images/latest-logo.png")}
            alt="loading"
            className="img-fluid"
          /> */}
          {/* <div className="loader"></div> */}
        </div>
      }
    >
      <Routes>
        <Route exact path="/" element={<PromotionHeader />}></Route>
        <Route path="/login" element={<AdminLogin />}></Route>
        <Route path="/edit_profile" element={<EditProfile />}></Route>
        <Route path="/change_password" element={<ChangePassword />}></Route>

        {/* Home Configration */}
        <Route path="/login-popup" element={<LoginPopUp />}></Route>
        <Route path="/promotion-header" element={<PromotionHeader />}></Route>
        <Route path="/sub-header" element={<SubHeader />}></Route>
        <Route path="/header" element={<Header />}></Route>
        <Route path="/slider-pattern" element={<SliderPattern />}></Route>
        <Route path="/category-pattern" element={<CategoryPatterns />}></Route>
        <Route path="/offer-pattern" element={<OfferBannerPattern />}></Route>
        <Route path="/hot-deal" element={<HotDealPattern />}></Route>
        <Route path="/new-arrival" element={<NewArrivalPattern />}></Route>
        <Route path="/best-seller" element={<BestSellerPattern />}></Route>
        <Route
          path="/recently-viewed"
          element={<RecentlyViewedPattern />}
        ></Route>
        <Route path="/footer-pattern" element={<FooterPattern />}></Route>
        <Route path="/promises" element={<Promises />}></Route>

        {/* Products Configratoin */}
        <Route path="/products-pattern" element={<ProductsPattern />}></Route>

        {/* ProductDetails Configration */}
        <Route
          path="/product-details-pattern"
          element={<ProductsDetailsPattern />}
        ></Route>
        <Route
          path="/relatedn-product-pattern"
          element={<RelatedProductPattern />}
        ></Route>

        {/* Products Configratoin */}
        <Route path="/wishlist-pattern" element={<WishListPattern />}></Route>
        {/* Products Configratoin */}
        <Route path="/cart-pattern" element={<CartPattern />}></Route>
        <Route
          path="/play-store-apps-link-pattern"
          element={<InstallAppsConfig />}
        ></Route>

        {/* image gallery */}
        <Route path="/gallery" element={<ImageGallery />}></Route>

        {/* settings */}
        <Route path="/business-details" element={<BusinessDetails />}></Route>
        <Route path="/smtp" element={<Smtp />}></Route>
        <Route path="/payment-gateway" element={<PaymentGateway />}></Route>

        {/* push notification settings */}
        <Route
          path="/setting/push-notification"
          element={<PushNotificationSetting />}
        ></Route>
        <Route
          path="/setting/whatsapp-setting"
          element={<WhatsappSetting />}
        ></Route>

        {/* App Configration */}
        <Route path="/app/header" element={<AppHeader />}></Route>
        <Route path="/app/slider" element={<AppSlider />}></Route>
        <Route path="/app/category" element={<AppCategoryPatterns />}></Route>
        <Route path="/app/offer-banner" element={<AppOfferBanner />}></Route>
        <Route path="/app/product/hot-deal" element={<AppHotDeal />}></Route>
        <Route
          path="/app/product/best-seller"
          element={<AppBestSeller />}
        ></Route>
        <Route
          path="/app/product/new-arrival"
          element={<AppNewArrival />}
        ></Route>
        <Route path="/app/promises" element={<AppPromises />}></Route>
        <Route path="/app/tab-bar" element={<AppTabBar />}></Route>
        <Route path="/app/splash-screen" element={<SplashScreen />}></Route>

        {/* proudct page */}
        <Route path="/app/product" element={<ProductList />}></Route>
        <Route path="/app/product-details" element={<ProductDetails />}></Route>
        {/* menu */}
        <Route path="/app/menu" element={<MenuPage />}></Route>
        <Route path="/app/checkout" element={<CheckOutPage />}></Route>

        {/* admin */}
        <Route path="/admin/menu" element={<AdminMenuPage />}></Route>
      </Routes>
    </Suspense>
  );
};

export default Routing;
